import styled from "styled-components";
import CheckboxControl from "../../../../Tracking/components/NFFilters/components/CheckboxControl";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 14px;
  align-items: center;
  border-bottom: 1px solid #00000018;
`;

export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  gap: 4px;
`;

export const ContainerCheckbox = styled.div`
  display: flex;
`;

export const WrapperChart = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
`;

export const StyledCheckbox = styled(CheckboxControl)`
  padding: 0;
  padding-top: 0;
  padding-left: 0;
  margin-left: 0;
  margin-right: 0;
`;

export const Label = styled.p`
  font-weight: 700;
  font-family: 'Work Sans';
  font-size: 14px;
  color: ${({ color }) => color || '#000'};
  margin: 0;
`;

export const PercentLabel = styled.p`
  position: absolute;
  align-self: center;
  justify-self: center;
  font-weight: 400;
  font-family: 'Work Sans';
  font-size: 12px;
  color: #00000099;
  margin: 0;
`;

export const Counter = styled.p`
  font-weight: 400;
  font-family: 'Work Sans';
  font-size: 14px;
  margin: 0;
`;
